import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {LiabilityDisclaimerContent} from "@/customComponents/globalComponents/policiesContent.jsx";

// Shared "Liability Disclaimer" copy lives in globalComponents/policiesContent.jsx.
// Re-exported here for the policies list (policiesListing) and the smart-suggestion
// info popup (desktop .upper-modal in smartTimeSelect / mobile overlay step below).
export {LiabilityDisclaimerContent};

// Mobile overlay step (opened via POPUP_STEPS). Desktop opens the same content
// inline as an .upper-modal, so this step is mobile-only in practice. ✕ closes
// (pops the overlay back to the screen underneath).
export function LiabilityDisclaimer({setStep, closeModal}) {
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={true} cancelButtonType="icon" showBackButton={false} setStep={setStep} closeModal={closeModal}/>
            {/* .hopn-policies-disclaimer scopes the green ".hopn-disclaimer-box" styling
                (it lives under that parent), so the popup matches the policies list. */}
            <div className="hopn-policies-disclaimer modalPages-spacing pb-8">
                <LiabilityDisclaimerContent/>
            </div>
        </>
    );
}
export default LiabilityDisclaimer;
